export default __webpack_public_path__ + "static/media/blob_02.1caa2f7f.mp4";